import {Component, ViewChild} from '@angular/core';
import {BaseModalComponent} from "common-shared";
import {BehaviorSubject, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {ConfigurationModel} from "../configuration.model";
import {ConfigurationDataService} from "../configuration-data.service";
import {ConfigurationDataEditComponent} from "../configuration-data-edit/configuration-data-edit.component";
import {Router} from "@angular/router";

@Component({
  selector: 'app-configuration-data-edit-modal',
  templateUrl: './configuration-data-edit-modal.component.html',
  styles: []
})
export class ConfigurationDataEditModalComponent extends BaseModalComponent {
  @ViewChild(ConfigurationDataEditComponent, {static: true}) editComponent: ConfigurationDataEditComponent;
  entityId: string;
  configuration: ConfigurationModel;
  isPristine$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  wasValidated$: Subject<boolean> = new Subject<boolean>();
  shouldResetSaveState$: Subject<boolean> = new Subject<boolean>();
  readonly = false;
  currentTab: 'general' | 'ime';

  constructor(private configurationDataService: ConfigurationDataService, private router: Router) {
    super();
  }

  ngOnInit() {
    if (this.entityId) {
      this.configurationDataService.get(this.entityId).pipe(takeUntil(this.componentDestroyed)).subscribe(configuration => {
        this.configuration = configuration
      });
    }
  }

  onChanged(isPristine: boolean) {
    this.isPristine$.next(isPristine);
  }

  save(withClose: boolean = true) {
    this.wasValidated$.next(true);
    if (this.configuration.isValid()) {
      this.configurationDataService.save(this.configuration).pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
        this.entityId = value.Id;
        this.apply(null, 'save');
        if (withClose) {
          this.close();
        } else {
          this.configuration = value;
          this.editComponent.initialize(this.configuration);
          this.shouldResetSaveState$.next(true);
        }
      });
    } else {
      this.currentTab = 'general';
    }
  }

  delete() {
    this.configurationDataService.remove(this.configuration).subscribe(() => {
      const shouldLeaveRoute = this.router.routerState.snapshot.url.includes(this.entityId);
      this.configuration = null;
      this.entityId = null;

      if (shouldLeaveRoute) {
        this.router.navigate(['/']);
      }
      this.close();
    });
  }
}
